import { privateApi } from 'services';
import { AutomationRule, PostAutomationRule, PutAutomationRule, ReprirotizeAutomationRules } from './types';
import { privateApiWithRouteLeavingCancelation } from '../ApiService/ApiServiceWithRouteLeavingCancelation';

const createAutomationRule = (payload: PostAutomationRule, businessAccountId: string): Promise<AutomationRule> =>
    privateApi.post<AutomationRule>(`business-accounts/${businessAccountId}/leads/journey-automations`, payload);

const enableAutomationRule = (leadsRuleId: string): Promise<void> =>
    privateApi.post<void>(`journey-automations/${leadsRuleId}/enable`);

const disableAutomationRule = (leadsRuleId: string): Promise<void> =>
    privateApi.post<void>(`journey-automations/${leadsRuleId}/disable`);

const editAutomationRule = (payload: PutAutomationRule, ruleId: string): Promise<AutomationRule> =>
    privateApi.put<AutomationRule>(`journey-automations/${ruleId}`, payload);

const reproritizeAutomationRule = (businessAccountId: string, payload: ReprirotizeAutomationRules): Promise<void> =>
    privateApi.post<void>(`business-accounts/${businessAccountId}/leads/journey-automations/reprioritize`, payload);

export const AutomationRulesGateway = {
    createAutomationRule,
    enableAutomationRule,
    disableAutomationRule,
    editAutomationRule,
    reproritizeAutomationRule,
};

const cancelableFetchAutomationRules = (businessAccountId: string): Promise<AutomationRule[]> =>
    privateApiWithRouteLeavingCancelation.getWithAbortControl<AutomationRule[]>(
        `business-accounts/${businessAccountId}/leads/journey-automations`,
    );

export const CancelableAutomationRulesGateway = {
    cancelableFetchAutomationRules,
};
